<template>
  <div>
    <p v-if="filter_match">
      <b-button variant="link" class="mr-2 px-2 py-1" v-b-toggle="ou.fq_name + '-children'"
                :style="{color: (ou.fq_name).toHSL()}"
                v-if="ous_by_parent[ou.fq_name] && ous_by_parent[ou.fq_name].length > 0">
        <netvs-icon class="collapse-icon" icon="collapse"></netvs-icon>
      </b-button>
      <b-link class="mr-3" :to="'/org/ou/'+ou.fq_name" v-if="$t_netdb(ou.title)">{{ $t_netdb(ou.title) }} ({{ ou.short_name }})</b-link>
      <b-link class="mr-3" :to="'/org/ou/'+ou.fq_name" v-else>{{ ou.short_name }}</b-link>
      <b-badge v-if="ou.ext_orgdata_key == null" variant="secondary"
               :id="'netvs-exclusive-ou-' + ou.fq_name">
        {{ $t('views.org.ou.netvs_exclusive') }}
      </b-badge>
      <b-tooltip v-if="ou.ext_orgdata_key == null" :target="'netvs-exclusive-ou-' + ou.fq_name"
                 triggers="hover" variant="secondary">
        {{ $t('views.org.ou.netvs_exclusive_tooltip') }}
      </b-tooltip>
      <b-button v-if="can_edit_ou" variant="link" :id="'edit-ou-' + ou.fq_name"
                @click="edit_ou(ou)" class="m-0 p-0">
        <netvs-icon icon="edit"></netvs-icon>
      </b-button>
      <b-button v-if="can_create_ou" variant="link" :id="'create-ou-' + ou.fq_name"
                @click="create_ou(ou)" class="m-0 p-0 ml-1">
        <netvs-icon icon="create"></netvs-icon>
      </b-button>
    </p>
    <div class="pl-4 ml-2" v-if="ous_by_parent[ou.fq_name]"
         :style="{'border-left': `6px solid ${(ou.fq_name).toHSL()}`, borderRadius: '14px'}">
      <b-collapse :id="ou.fq_name + '-children'" visible>
        <OUTreeEntry v-for="child_ou in ous_by_parent[ou.fq_name]" :key="child_ou.short_name" :ou="child_ou"
                     :ous_by_parent="ous_by_parent" :edit_ou="edit_ou" :create_ou="create_ou" :filter="filter"/>
      </b-collapse>
    </div>
  </div>
</template>

<script>

import apiutil from '@/util/apiutil'

/**
 * @displayName OUTreeEntry
 * @description Component for recursive rendering of OU tree
 */
export default {
  name: 'OUTreeEntry',
  props: {
    ou: {
      type: Object,
      required: true
    },
    ous_by_parent: {
      type: Object,
      required: true
    },
    edit_ou: {
      type: Function,
      required: false,
      default: (ou) => {
        window.console.log('No DBEditor handler was passed to edit', ou)
      }
    },
    create_ou: {
      type: Function,
      required: false,
      default: (ou) => {
        window.console.log('No DBEditor handler was passed to create sub-ou for', ou)
      }
    },
    can_create_ou: {
      type: Boolean,
      required: false,
      default: false
    },
    filter: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      db_editor_presets: this.ou
    }
  },
  computed: {
    filter_match() {
      return this.filter === '' ||
        this.ou.fq_name.toLowerCase().includes(this.filter.toLowerCase()) ||
        this.ou.short_name.toLowerCase().includes(this.filter.toLowerCase()) ||
        (this.ou.ext_orgdata_key != null && this.ou.ext_orgdata_key.toLowerCase().includes(this.filter.toLowerCase()))
    },
    can_edit_ou() {
      return apiutil.checkPermission(this.$store.state, 'org.rw:unit')
    }
  },
}
</script>

<style scoped>
.not-collapsed > .collapse-icon {
  transform: rotate(-180deg);
}
</style>
